/** Internal helper imports here ... */

/**
 * Module description...
 *
 * @returns {{init: init}}
 */
const readMoreAccs = (() => {
  const DOM = {};

  const cacheDOM = () => {
    DOM.readMoreAcc = document.getElementsByClassName('read-more-accordion');
    DOM.readMoreHidden = document.getElementsByClassName('read-more-content--hide');
  };

  const showText = (event, i) => {
    event.preventDefault();
    if (DOM.readMoreHidden[i].classList.contains('open')) {
      DOM.readMoreHidden[i].classList.remove('open');
      DOM.readMoreHidden[i].setAttribute('style', 'height: 0');
      DOM.readMoreAcc[i].innerHTML = 'Read More';
    } else {
      let int = DOM.readMoreHidden[i].scrollHeight + 'px';
      console.log(int);
      DOM.readMoreHidden[i].classList.add('open');
      DOM.readMoreHidden[i].removeAttribute('style');
      DOM.readMoreAcc[i].innerHTML = 'Read Less';
      DOM.readMoreHidden[i].style.height = DOM.readMoreHidden[i].scrollHeight + 'px';
    }
  };

  const eventListeners = () => {
    for (let i = 0; i < DOM.readMoreAcc.length; i++) {
      DOM.readMoreAcc[i].addEventListener("click", () => {
        showText(event, i);
      });
    }
  };

  function init() {
    cacheDOM();
    console.log('in now');
    eventListeners();
  }

  return {
    init
  };
})();

export default readMoreAccs;
